import React, {Component} from 'react';

export default class BackgroundShapes extends Component {

  render() {
    return (
      <div className="BackgroundShapes" Id="BackgroundShapes">
        <div className="BackgroundShapes__Shape BackgroundShapes__Shape--1"></div>
        <div className="BackgroundShapes__Shape BackgroundShapes__Shape--2"></div>
        <div className="BackgroundShapes__Shape BackgroundShapes__Shape--3"></div>
        <div className="BackgroundShapes__Shape BackgroundShapes__Shape--4"></div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Content/BackgroundShapes/BackgroundShapes.js